import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { CmsItemComponent } from './cms-item/cms-item.component';
import { CmsManagmentComponent } from './cms-management.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        CmsItemComponent,
        CmsManagmentComponent
    ],
    entryComponents: [CmsManagmentComponent],
    exports: [CmsManagmentComponent]
})
export class CmsManagementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/cms-management/cms-management.module.ts